import { flexRender } from '@tanstack/react-table';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import Box from 'shared_DEPRECATED/components/Box';
import Spacer from 'shared_DEPRECATED/components/Spacer';
import { Spacers } from 'shared_DEPRECATED/components/Spacer/Spacers';

import {
  SessionsTableHeaderCell,
  SessionsTableSectionTitle,
} from 'features/sessions/components/Table';
import {
  SessionListItemType,
  SessionTableItemType,
} from 'features/sessions/config/types';
import { useCoachTableData } from 'features/sessions/hooks';

import styles from './Table.module.css';

type CoachSessionsTablePropsType = {
  sessions: SessionListItemType[];
};

export const CoachSessionsTable = ({
  sessions,
}: CoachSessionsTablePropsType) => {
  const table = useCoachTableData(sessions);
  const navigate = useNavigate();

  const handleRowClick = (coachingSessionId: string) => {
    navigate(coachingSessionId);
  };

  return (
    <Spacers sizes={['zr lg', 'zr md']}>
      <Box
        style={{
          borderRadius: '0.5rem',
          overflow: 'hidden',
          border: 'var(--border-secondary)',
        }}
      >
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
          }}
        >
          <thead
            style={{
              backgroundColor: 'var(--bgCompSecondaryBig)',
              borderBottom: 'var(--border-secondary)',
            }}
          >
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    onClick={header.column.getToggleSortingHandler()}
                    style={{
                      cursor: header.column.getCanSort()
                        ? 'pointer'
                        : 'default',
                      textAlign: 'left',
                    }}
                  >
                    <SessionsTableHeaderCell header={header} />
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row, index) => {
              return (
                <React.Fragment key={row.id}>
                  <SessionsTableSectionTitle
                    currentSession={row.original as SessionTableItemType}
                    prevSession={
                      table.getRowModel().rows[index - 1]?.original as
                        | SessionTableItemType
                        | undefined
                    }
                  />
                  <tr
                    key={`${row.id}-data`}
                    data-testid="sessions-table-row"
                    style={{
                      borderBottom: 'var(--border-secondary)',
                    }}
                    className={styles.row}
                    onClick={() =>
                      handleRowClick(
                        (row.original as SessionTableItemType).coachingSessionId
                      )
                    }
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id}>
                        <Spacer size="lg">
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </Spacer>
                      </td>
                    ))}
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </Box>
    </Spacers>
  );
};
